import React, { useMemo } from 'react';

import {
  removeEditableFlags,
  removeHandlebarsEach,
} from '@common/helpers/helpers';

import useCurrentLanguageEditorState from '@hooks/useCurrentLanguageEditorState';
import { Box } from '@mui/material';
import EditorHeader from '@pages/TemplateEditor/components/EditorHeader';

export default function PreviewStep() {
  const { currentLanguageEditorState } = useCurrentLanguageEditorState();

  const notEditableSrc = useMemo(() => {
    return removeEditableFlags(
      removeHandlebarsEach(currentLanguageEditorState?.HTMLdata || ''),
    );
  }, [currentLanguageEditorState]);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <EditorHeader />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: 'lightgray',
        }}
      >
        <iframe
          style={{
            height: 'calc(100vh - 200px)',
            width: '100%',
            border: 'none',
            overflow: 'auto',
          }}
          title='pdf-preview'
          srcDoc={notEditableSrc}
        />
      </Box>
    </Box>
  );
}
